<template>
    <div>
        <raw-page-header :title="title" @edit-raw-data="$_editRawData(FieldDataTableCode)" />

        <div v-if="rawData" class="row">
            <div class="col-sm-12 col-md-6 col-lg-6">
                <div class="std-padding white-bg card">
                    <p class="sectionTitle">Raw Data</p>
                    <table id="fatty-acid-detail-table" class="table">
                        <tr>
                            <th>No.</th>
                            <th>Title</th>
                            <th>Data</th>
                        </tr>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Palm ID</td>
                                <td>{{ rawData.palmTrialPalmId }}</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Status</td>
                                <td v-html="getStatusBtn(rawData)" />
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Flag</td>
                                <td v-html="getFlagData(rawData)" />
                            </tr>
                            <tr v-for="(rawVariable, index) in FattyAcidRawVariables" :key="'rawVariable'+index">
                                <td>{{ index+4 }}</td>
                                <td>{{ rawVariable.title }}</td>
                                <td>{{ getData(rawVariable.data) }}</td>
                            </tr>
                            <tr>
                                <td>13</td>
                                <td>Record Date</td>
                                <td>{{ formatCreationTime(dateTimeValue) }}</td>
                            </tr>
                            <tr>
                                <td>14</td>
                                <td>Created By</td>
                                <td>{{ (rawData.creatorUser||{}).userName || '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="col-sm-12 col-md-6 col-lg-6">
                <div class="std-padding white-bg height100 card">
                    <p class="changes-history-title">Changes History</p>
                    <edit-history-table ref="historyTable" :field-data-name="FieldDataCategory" :raw-data-id="paramID" />
                </div>
            </div>
        </div>

        <general-dialog v-if="dynamicForm" :dialog.sync="editDialog" :header="editDialogHeader">
            <template #content>
                <dynamic-form ref="dynamicForm" 
                              :dynamic-form="dynamicForm"
                />

                <div class="dateTime-container">
                    <span class="demonstration">Record Date: </span>
                    <el-date-picker
                        v-model="dateTimeValue"
                        class="dateTime-input"
                        type="datetime"
                        placeholder="Select date and time"
                    />
                </div>
            </template>
            <template #action>
                <v-btn color="agrinome_primary" dark @click="updateData()">Update</v-btn>
            </template>
        </general-dialog>

        <general-dialog :dialog.sync="isConfirmDialog" :header="isConfirmDialogHeader">
            <template #content>
                Are you sure to update this?
            </template>
            <template #action>
                <v-btn color="agrinome_primary" dark @click="$_comfirmUpdateRawData(FieldDataCategory)">Yes</v-btn>
            </template>
        </general-dialog>

        <record-status-dialog 
            ref="recordDialog" 
            :api-info="ApiInfo" 
            :status-info="StatusInfo"
            :dialog.sync="dialog"
            :update-multiple="updateMultiple"
            @updated-success="updatedStatusSuccess()"
        />
    </div>
</template>

<script>
import FattyAcidRawVariable from "@/assets/json/fatty-acid-raw-variable.json";

export default {
    data() {
        return {
            data: null,
            paramID: null,
            title: "Fatty Acid Raw Detail",

            editDialog: false,
            editDialogHeader: "Edit Fatty Acid Raw",
            dynamicForm: null,

            isConfirmDialog: false,
            isConfirmDialogHeader: "Are you sure to update the data?",

            FieldDataCategory: "FattyAcidData",
            FieldDataTableCode: "FATTY_ACID",

            dateTimeValue: null,

            rawData: null,

            dialog: false,
            ApiInfo: {
                Table: "FattyAcidData",
                UpdateManyKey: "fattyAcidDataList",
                RepopulateMeanApi: "RepopulateFattyAcidDerivedData"
            },
            StatusInfo: null,
            updateMultiple: false,

            tableId: "#fatty-acid-detail-table"
        };
    },
    computed: {
        FattyAcidRawVariables() {
            return FattyAcidRawVariable;
        }
    },
    mounted() {
        this.$nextTick(function() {
            this.paramID = this.$route.params.id;
            this.getRawData();
        });
    },
    methods: {
        updatedStatusSuccess() {
            this.getRawData();
            this.getHistoryData();
        },
        getFlagData(rawData) {
            var flagVariable = "fattyAcidFlaggedDatas";
            var flagLength = rawData[flagVariable].length;
            setTimeout(function() { $("[data-toggle=\"tooltip\"]").tooltip(); }, 500);
            return this.$_getFlagTooltip(rawData, flagLength, flagVariable);
        },
        getStatusBtn(data) {
            var self = this;
            var value = data.status ? data.status : "&nbsp;&nbsp;-&nbsp;&nbsp;";
            setTimeout(function() { self.$_tableStatus(self.tableId); }, 500);
            return this.$_getStatusBtn(data.id, value);
        },
        getRawData() {
            var self = this;
            axios({
                method: "GET",
                url: "FattyAcidData/Get",
                cache: {
                    ignoreCache: true,
                },
                params: {
                    Id: this.paramID
                }
            })
                .then(function (response) {
                    self.rawData = response.data.result;
                    self.dateTimeValue = response.data.result.recordDate;
                });
        },
        updateData() {
            this.editDialog = false;
            this.isConfirmDialog = true;
        },
        getHistoryData() {
            this.$refs.historyTable.redrawTable();
        },
        getData(title) {
            return this.addTo2Decimal(this.rawData[title]);
        }
    }
};
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Palm/PalmRawDetail/RawFattyAcidDetail.vue